import {
  ENABLEMENT_PROVIDER_SLUGS,
  partnerEnablementPath,
} from '@/integrations/enablement/providers';
import { stripLocalePathPrefix } from '@heidi/utils/i18n';

/**
 * Routes where session replay (Datadog RUM and PostHog) must not start. A
 * recorder's first snapshot carries `location.href` before any effect runs and
 * the URL redactors never reach replay payloads, so this is decided at init.
 * `/auth/onboard` arrives with Auth0's `?state=` and `?session_token=`, and a
 * rejected token is rewritten to `/auth/onboard-expired` with that URL intact.
 * The team invite landing routes (`/join-team`, `/new-team-user`) carry the
 * invited address and team in the query string.
 * Partner enablement carries a partner JWT (`?context=`) or a one-shot OAuth
 * `code`/`state` pair on the same public route — paths come from
 * `ENABLEMENT_PROVIDERS` so a new slug cannot omit the block.
 */
const SESSION_REPLAY_BLOCKED_PATHS = new Set([
  '/auth/onboard',
  '/auth/onboard-expired',
  '/join-team',
  '/new-team-user',
  ...ENABLEMENT_PROVIDER_SLUGS.map(partnerEnablementPath),
]);

export function isSessionReplayBlockedRoute(pathname: string): boolean {
  const path = stripLocalePathPrefix(pathname).replace(/\/+$/, '') || '/';
  return SESSION_REPLAY_BLOCKED_PATHS.has(path);
}
